import { marketProjectsFailureHandler } from './market-projects-failure.handler';

export const MARKET_MOCK_HANDLERS = [marketProjectsFailureHandler];
